import moment from "moment";
import React, { useState } from "react";
import submit from "submit-form";
import Modal from "../../modal-new";

export const PhaseDescriptionModal = ({
  athleteId,
  dateAttachment,
  phaseDescriptionStatus,
  phaseDescription = "",
  organizationCoachId
}) => {
  const [phaseDescriptionState, setPhaseDescriptionState] =
    useState(phaseDescription);
  const [phaseDescriptionStatusState, setPhaseDescriptionStatusState] =
    useState(phaseDescriptionStatus);

  const readMode = phaseDescriptionStatusState === "read";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!phaseDescriptionState.length) return;
    const url = phaseDescription.length
      ? "/actions/annual-planner/update-athlete-phase-description"
      : "/actions/annual-planner/set-athlete-phase-description";

    if (phaseDescriptionState !== phaseDescription) {
      let body = {
        phaseDescription: phaseDescriptionState,
        dateAttachment: moment(dateAttachment, "MMM D, YYYY").format(
          "YYYYMMDD"
        ),
        athleteId,
      };

      if (organizationCoachId) {
        body = { ...body, organizationCoachId };
      }
      setPhaseDescriptionStatusState("read");
      submit(url, {
        method: "POST",
        body,
      });
    } else setPhaseDescriptionStatusState("read");
  };

  const openRemovePhaseDescriptionModal = () => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        "modal[type]": "remove-phase-description",
        phaseDescription: phaseDescriptionState,
        dateAttachment,
        athleteId,
      },
    });
  };

  const handleCancelEdit = () => {
    if (!phaseDescription) {
      return submit("/actions/refresh", {
        method: "GET",
        body: {
          "modal[type]": "",
          phaseDescription: "",
          dateAttachment: "",
          athleteId: "",
        },
      });
    }
    setPhaseDescriptionStatusState("read");
    setPhaseDescriptionState(phaseDescription);
  };

  return (
    <Modal
      className="annual-planner-modal phase-description-modal"
      title={"Phase Description"}
    >
      <div className="body">
        <form
          className="annual-planner-modal-form phase-description-modal-form"
          onSubmit={handleSubmit}
          encType="multipart/form-data"
          id="phase-description-form"
        >
          <div role="wrapper" className="phase-description-date">
            <label>Date</label>
            <label>{dateAttachment}</label>
          </div>

          <div role="wrapper" className="phase-description">
            <label>Description</label>
            {readMode ? (
              <span className="phase-description">{phaseDescriptionState}</span>
            ) : (
              <textarea
                type={"textarea"}
                name="phase_description"
                className="phase-description"
                placeholder="Enter description here..."
                value={phaseDescriptionState}
                onChange={({ target: { value } }) =>
                  setPhaseDescriptionState(value)
                }
                autoFocus
              />
            )}
          </div>
        </form>
      </div>
      {readMode ? (
        <footer className="read">
          <button
            type="button"
            onClick={openRemovePhaseDescriptionModal}
            role="button"
            data-action="delete"
          >
            <img src="/img/new-icons/red-trash.svg" />
            Delete
          </button>
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              setPhaseDescriptionStatusState("edit");
            }}
            role="button"
            data-button-type="secondary"
          >
            Edit
          </button>
        </footer>
      ) : (
        <footer className="editing">
          <button
            type="button"
            onClick={() => handleCancelEdit()}
            role="button"
            data-action="cancel"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={!phaseDescriptionState.length}
            role="button"
            data-button-type="primary"
            form="phase-description-form"
          >
            Save
          </button>
        </footer>
      )}
    </Modal>
  );
};
